export enum QuestionTypeEnum {

    text = 1,
    checkbox = 2,
    radio = 3,
    star = 4,
    image = 5,
    dynList = 6,
    fixListProduct = 7,
    none = -1
}